import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

export function SuccessBody() {
  const texts = useTexts()

  return (
    <Alert severity="success" icon={false}>
      <AlertTitle>{texts.successTitle}</AlertTitle>
      {texts.successDescription}
    </Alert>
  )
}
